import { render, staticRenderFns } from "./user-settings.vue?vue&type=template&id=8036f41c&scoped=true"
import script from "./user-settings.vue?vue&type=script&lang=js"
export * from "./user-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8036f41c",
  null
  
)

export default component.exports